import React, { memo } from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { InputPanel } from './InputPanel';
import { PromptsList } from './PromptsList';
import { PromptType, EntryScreenProps } from '../types';

const EntryContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  width: '100%',
  padding: theme.spacing(4),
  backgroundColor: theme.palette.background.default,
  gap: theme.spacing(4),
}));

const EntryQuestion = styled(Typography)(({ theme }) => ({
  fontSize: '2rem',
  fontWeight: 600,
  color: theme.palette.text.primary,
  textAlign: 'center',
  marginBottom: theme.spacing(2),
}));

export const EntryScreen: React.FC<EntryScreenProps> = memo(({
  entryQuestion,
  prompts,
  onSubmit,
  loading = false,
  placeholder = 'Ask Mia anything....',
}) => {
  const handlePromptClick = (prompt: PromptType | string) => {
    const text = typeof prompt === 'string' 
      ? prompt 
      : prompt.text;
    onSubmit(text);
  }

  return (
    <EntryContainer>
      <EntryQuestion>{entryQuestion}</EntryQuestion>

        <InputPanel
          variant="entry"
          placeholder={placeholder}
          onSend={onSubmit}
          disabled={loading}
        />

      {prompts.length > 0 && (
        <PromptsList
          prompts={prompts}
          onClick={handlePromptClick}
          disabled={loading}
        />
      )}
    </EntryContainer>
  );
});

EntryScreen.displayName = 'EntryScreen';

